// ═══════════════════════════════════════════════════════════════
// V·IANet Governance — Viewer-specific CSS styles
// ═══════════════════════════════════════════════════════════════

import { generateViewerCSS } from '../../../../../config/documentStyles';

export function ViewerStyles() {
  return (
    <style>{`
      ${generateViewerCSS()}

      .a4-scroll-area { overflow-x: auto; }
      .sbtn {
        padding: 4px 8px; border-radius: 4px; border: 1px solid #e2e8f0;
        background: white; cursor: pointer; font-size: 12px; font-family: inherit;
        color: #5A6171; min-width: 28px; text-align: center;
      }
      .sbtn:hover { background: #f1f5f9; }

      /* Tables: prevent overflow */
      .viewer-content table {
        max-width: 100%;
        display: block;
        overflow-x: auto;
      }
      .viewer-content table table {
        display: table;
      }

      /* Last page: extra padding to prevent text cut */
      [data-a4-page] .viewer-content > *:last-child {
        padding-bottom: 12px;
      }

      /* TipTap editor styles */
      .tiptap-editor .ProseMirror { outline: none; min-height: 400px; }
      .tiptap-editor .ProseMirror:focus { outline: none; }
      .tiptap-editor .ProseMirror > * + * { margin-top: 0.5em; }

      @media (max-width: 767px) {
        .sidebar {
          position: fixed !important; top: 53px; left: 0; bottom: 0;
          z-index: 250; transform: translateX(-100%); transition: transform 0.25s ease;
        }
        .sidebar.sidebar-open { transform: translateX(0) !important; }
        .sidebar-overlay { display: block !important; }
        .mobile-menu-btn { display: flex !important; }
        .header-info { display: none !important; }
        .a4-scroll-area > div[style] { width: 100% !important; height: auto !important; transform: none !important; margin-bottom: 0 !important; }
        .wf-btn { min-height: 44px; flex: 1; }
        .lifecycle-stepper { flex-direction: column !important; align-items: flex-start !important; }
        .lifecycle-stepper > div { flex-direction: row !important; }
      }
      @media (min-width: 768px) and (max-width: 1024px) {
        .sidebar {
          position: fixed !important; top: 53px; left: 0; bottom: 0;
          z-index: 250; transform: translateX(-100%); transition: transform 0.25s ease;
        }
        .sidebar.sidebar-open { transform: translateX(0) !important; }
        .sidebar-overlay { display: block !important; }
        .mobile-menu-btn { display: flex !important; }
      }
    `}</style>
  );
}
